import { render } from "./side-nav-outer-toolbar.vue?vue&type=template&id=5e8a1950"
import script from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"
export * from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"

import "./side-nav-outer-toolbar.vue?vue&type=style&index=0&id=5e8a1950&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__